const COOKIE_NAME = "EXPERIENCE_VARIANT";
const COOKIE_MAX_AGE = 60 * 60 * 24 * 30; // 30 days

export function getExperienceVariant(): string {
  if (typeof document === "undefined") return "";
  const match = document.cookie.match(new RegExp(`${COOKIE_NAME}=([^;]+)`));
  return match ? decodeURIComponent(match[1]) : "";
}

/** Pass null to clear. */
export function setExperienceVariant(variantId: string | null): void {
  if (typeof document === "undefined") return;

  if (!variantId) {
    document.cookie = `${COOKIE_NAME}=; path=/; max-age=0`;
  } else {
    document.cookie = `${COOKIE_NAME}=${encodeURIComponent(variantId)}; path=/; max-age=${COOKIE_MAX_AGE}`;
  }
}
